import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export interface IAbroadRepresentativeState {
  data?: {abroad_representatives?: any[]; meta?: {[key: string]: number}}
  loading?: boolean
  saving?: boolean
  success?: boolean
  // 'delete' | 'enable' | 'disable' after a successful bulk call
  bulkDone?: string
}

const initialState: IAbroadRepresentativeState = {
  data: {abroad_representatives: [], meta: {}},
  loading: false,
  saving: false,
  success: false,
  bulkDone: '',
}

export const reducer = (
  state: IAbroadRepresentativeState = initialState,
  action: ActionWithPayload<any>
): IAbroadRepresentativeState => {
  switch (action.type) {
    case actionTypes.GET_ABROAD_REPRESENTATIVE_START:
      return {...state, loading: true}
    case actionTypes.GET_ABROAD_REPRESENTATIVE_SUCCESS:
      return {...state, data: action.payload, loading: false}
    case actionTypes.GET_ABROAD_REPRESENTATIVE_FINISH:
      return {...state, loading: false}

    case actionTypes.ADD_ABROAD_REPRESENTATIVE_START:
    case actionTypes.UPDATE_ABROAD_REPRESENTATIVE_START:
      return {...state, saving: true, success: false}
    case actionTypes.SAVE_ABROAD_REPRESENTATIVE_SUCCESS:
      return {...state, saving: false, success: true}
    case actionTypes.SAVE_ABROAD_REPRESENTATIVE_FINISH:
      return {...state, saving: false}

    case actionTypes.BULK_ABROAD_REPRESENTATIVE_START:
      return {...state, loading: true, bulkDone: ''}
    case actionTypes.BULK_ABROAD_REPRESENTATIVE_SUCCESS:
      return {...state, loading: false, bulkDone: action.payload}
    case actionTypes.BULK_ABROAD_REPRESENTATIVE_FINISH:
      return {...state, loading: false}

    case actionTypes.RESET_ABROAD_REPRESENTATIVE:
      return {...state, success: false, bulkDone: ''}
    default:
      return state
  }
}
